document.addEventListener('DOMContentLoaded', () => {
    const courseContainer = document.querySelector('.course-idv');
    if (!courseContainer) return;

    const programName = courseContainer.dataset.program;
    if (!programName) return;

    const loader = document.getElementById('async-content-loader');

    async function loadCourseDetails() {
        try {
            const response = await fetch(`/api/program/course-idv?p=${encodeURIComponent(programName)}`);
            const result = await response.json();

            if (result.success) {
                updateUI(result.data);
                // Broadcast the loaded payload so page-local modules (enrollment popup,
                // login gating, etc.) can bind without duplicating the /api/program/course-idv fetch.
                document.dispatchEvent(new CustomEvent('course-idv:loaded', { detail: result.data }));
                // Smoothly fade out the central loader
                if (loader) {
                    loader.style.transition = 'opacity 0.4s ease';
                    loader.style.opacity = '0';
                    setTimeout(() => loader.style.display = 'none', 400);
                }
            } else {
                showError(result.message || 'Failed to load course details');
            }
        } catch (error) {
            console.error('Error loading course details:', error);
            showError('An error occurred while loading the course content.');
        }
    }

    function updateUI(data) {
        var program = data.programDetails;
 
        var overview = {
            "title": "A QUICK OVERVIEW OF COURSE",
            "items": [
                "Master n8n flow-grammed agents from scratch",
                "Build production-grade AI workflows in 20 hours",
                "Deploy to Traefik VPS with auto-SSL",
                "Hands-on RAG, MCP, multi-channel routing"
            ]
        };

        program.overview = program.overview || overview;
        
        // --- 1. Update Hero Section ---
        
        // Badge
        const badge = document.getElementById('enroll-badge');
        if (badge) {
            badge.innerHTML = program.category && program.category[0] ? program.category[0] : 'Master';
        }

        // Title
        const title = document.getElementById('enroll-title');
        if (title) {
            title.innerHTML = program.program_name;
        }

        // Banner Image
        const bannerContainer = document.querySelector('.course-idv__hero-banner');
        if (bannerContainer && program.thumbnail) {
            bannerContainer.innerHTML = `<img src="${program.thumbnail}" alt="${program.program_name}">`;
        }

        // Meta Items (Duration, Students)
        const metaContainer = document.getElementById('enroll-meta');
        if (metaContainer) {
            metaContainer.innerHTML = '';
            if (program.course_duration) {
                metaContainer.appendChild(createMetaItem('ri-time-line', program.course_duration));
            }
            if (data.studentsCount) {
                metaContainer.appendChild(createMetaItem('ri-group-line', `${data.studentsCount} Students`));
            }
        }

        // Price
        const priceNew = document.getElementById('enroll-price-new');
        if (priceNew && program.price) {
            priceNew.innerHTML = `₹${formatNumber(program.price)}+ Tax*`;
        }
        const priceOld = document.getElementById('enroll-price-old');
        if (priceOld && program.price) {
            const oldPrice = (program.price_old && program.price_old > 0) ? program.price_old : program.price * 3;
            priceOld.innerHTML = `₹${formatNumber(oldPrice)}`;
        }

        // Overview
        const overviewList = document.getElementById('enroll-overview-list');
        if (overviewList && program.overview && program.overview.items) {
            overviewList.innerHTML = '';
            program.overview.items.forEach(item => {
                const li = document.createElement('li');
                li.innerHTML = `<i class="ri-checkbox-circle-fill"></i> ${item}`;
                overviewList.appendChild(li);
            });
        }
        
        // Overview Title
        const overviewTitle = document.querySelector('#enroll-overview .overview-title');
        if (overviewTitle && program.overview && program.overview.title) {
            overviewTitle.innerHTML = program.overview.title;
        }

        // --- 2. Update Topics Section ---
        
        const topicsTitle = document.getElementById('topics-title');
        if (topicsTitle) {
            const rawTitle = `What Are The \`Topics Covered\` By Product ${program.program_name}?`;
            topicsTitle.innerHTML = renderHighlightedText(rawTitle, 'highlight');
        }

        const topicsContent = document.getElementById('topics-content');
        if (topicsContent && program.topics && program.topics.length) {
            topicsContent.innerHTML = '';
            program.topics.forEach(q => {
                const div = document.createElement('div');
                div.className = 'topic-item';
                div.innerHTML = `<p>${q}</p>`;
                topicsContent.appendChild(div);
            });
        }

        // --- 3. Update Benefits Section ---
        const benefitsGrid = document.querySelector('.course-idv__benefits-grid');
        if (benefitsGrid && program.benefits && program.benefits.length) {
            benefitsGrid.innerHTML = '';
            for (let i = 0; i < program.benefits.length; i += 3) {
                const col = document.createElement('div');
                col.className = 'benefits-col';
                program.benefits.slice(i, i + 3).forEach(benefit => {
                    const card = document.createElement('div');
                    card.className = 'benefit-card';
                    card.innerHTML = `
                        <div class="benefit-card__icon">
                            <img src="${benefit.image || ''}" alt="${benefit.tittle || benefit.title || ''}">
                        </div>
                        <h3 class="benefit-card__title">${benefit.tittle || benefit.title || ''}</h3>
                        <p class="benefit-card__desc">${benefit.description || ''}</p>
                    `;
                    col.appendChild(card);
                });
                benefitsGrid.appendChild(col);
            }
        }

        // --- 4. Update Master Section ---
        const masterSection = document.querySelector('.course-idv__master');
        if (masterSection && program.master) {
            const subtitle = masterSection.querySelector('.course-idv__section-subtitle');
            if (subtitle) {
                subtitle.removeAttribute('style');
                subtitle.textContent = program.master.subtitle || '';
            }
            const sectionTitle = masterSection.querySelector('.course-idv__section-title');
            if (sectionTitle) {
                sectionTitle.removeAttribute('style');
                sectionTitle.className = 'course-idv__section-title highlight';
                sectionTitle.innerHTML = renderHighlightedText(program.master.title || '', 'highlight');
            }
        }

        const skillsData = program.skills;
        if (skillsData && skillsData.items && skillsData.items.length) {
            const skillsHeader = document.querySelector('.course-idv__master [data-skills-header]');
            if (skillsHeader) {
                skillsHeader.className = skillsData.headerClass || 'skills-header';
                const skillsLabel = skillsHeader.querySelector('.label');
                if (skillsLabel) {
                    skillsLabel.removeAttribute('style');
                    skillsLabel.textContent = skillsData.header?.label || '';
                }
            }
            const skillsTrack = document.querySelector('.course-idv__master .skills-marquee .track');
            if (skillsTrack) {
                const buildItems = (items) => items.map(skill => {
                    const iconHtml = skill.iconType === 'image'
                        ? `<img class="w-[50px] h-[40px]" src="${skill.icon}" alt="${skill.name}">`
                        : `<i class="${skill.icon}"></i>`;
                    return `<div class="item">${iconHtml} ${skill.name}</div>`;
                }).join('');
                skillsTrack.removeAttribute('style');
                skillsTrack.innerHTML = buildItems(skillsData.items) + buildItems(skillsData.items);
            }
        }

        // --- 5. Update Enrollment Button ---
        updateEnrollmentButton(data.isLoggedIn, data.isCourseEnrolled, data.isPaid, data.isKycPending);
    }

    function createMetaItem(icon, text) {
        const span = document.createElement('span');
        span.className = 'meta-item';
        span.innerHTML = `<i class="${icon}"></i> ${text}`;
        return span;
    }

    function formatNumber(num) {
        return new Intl.NumberFormat('en-IN').format(num);
    }

    function renderHighlightedText(text, className) {
        const classAttr = className ? ` class="${className}"` : '';
        return String(text).replace(/`(.*?)`/g, `<span${classAttr}>$1</span>`);
    }

    function updateEnrollmentButton(isLoggedIn, isCourseEnrolled, isPaid, isKycPending) {
        const existingBtn = document.querySelector('.enroll-card__btn');
        if (!existingBtn) return;
        const span = existingBtn.querySelector('span');

        // Reset to a clean state every render.
        existingBtn.className = 'enroll-card__btn';
        existingBtn.removeAttribute('aria-disabled');
        existingBtn.style.pointerEvents = '';
        existingBtn.style.opacity = '';

        if (!isLoggedIn) {
            existingBtn.classList.add('login-required');
            existingBtn.href = '#';
            span.textContent = 'Enroll Now';
            return;
        }

        if (isCourseEnrolled) {
            if (isPaid) {
                // Enrolled and fully paid → go straight to the course.
                existingBtn.classList.add('go-to-course');
                existingBtn.href = 'https://academy.selfmade.ninja';
                span.textContent = 'Go to course';
            } else {
                // Enrolled (KYC verified) with fees pending → pay.
                existingBtn.classList.add('go-to-course', 'pay-now');
                existingBtn.href = '/myaccount?tab=payments';
                span.textContent = 'Pay Now';
            }
            return;
        }

        if (isKycPending) {
            // Application submitted but KYC not yet verified → disable.
            existingBtn.classList.add('enroll-now', 'is-disabled');
            existingBtn.href = '#';
            existingBtn.setAttribute('aria-disabled', 'true');
            existingBtn.style.pointerEvents = 'none';
            existingBtn.style.opacity = '0.55';
            span.textContent = 'Enroll Now';
            return;
        }

        // Logged in, not enrolled, no application → can enroll.
        existingBtn.classList.add('enroll-now');
        existingBtn.href = '#';
        span.textContent = 'Enroll Now';
    }

    function showError(message) {
        if (loader) {
            loader.innerHTML = `<p class="text-danger" style="font-weight: bold; font-size: 1.2rem;">${message}</p>
                                <button onclick="window.location.reload()" class="btn btn-sm btn-outline-info mt-2">Retry</button>`;
            loader.style.display = 'block';
            loader.style.opacity = '1';
        }
    }

    // Initialize the async load
    loadCourseDetails();
});
